import BaseObject from '../../../../base/base_object';
import Model from './on_demand_hybrid_model';
import {FEATURE_CB_FUNC, SERIVCES_FUNC_LIST, KEY_NAME, ON_DEMAND} from '../../native/native_const';
import Event from '../../../../utils/event';
import Device from '../../../../utils/device/device';
import {SYSTEM_EVENTS} from '../../../../events/events';
import _ from "../../../../utils/underscore";
import DOM from "../../../../utils/dom";



class OnDemand extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OnDemand';

    _HybridService = null;
    _isOdrRealProgress = true;
    _nTimeOut = 0;


    init(params) {

        this._model = Model.create(params);

        this._nTimeOut = this.getTimeOut();

        super.init(params);
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        if (Device.hybrid.isEmbedded) {
            this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.ON_DEMAND_SET_CB, FEATURE_CB_FUNC.HYBRID_ON_DEMAND_CALL);

            Event.on(SYSTEM_EVENTS.ODR_CLEAR_ALL_GAMES, () => {
                this.deleteAllOnDemandGames();
            });
        }

        return this;
    }

    inidFeature(){
        if (Device.hybrid.isEmbedded) {
            this.loadRemoteChill();
        }
    }

    loadRemoteChill() {

        if(!this._model.isEnableChillRemoteLoading()){
            return;
        }

        let gameOptions = {gameType:130043};

        this._HybridService.serviceFactory.gameService().readAnonymousGameConfiguration(gameOptions)
            .then(data => {
                let url = '';
                let ver = '';

                try{
                    url = this._getChillUrl(data.grsData.chillUrl);
                    ver = data.grsData.chillUrl;

                } catch (err) {
                    this._sendElasticEvent(ON_DEMAND.CHILL_LOADING_ERROR, 'Error in LoadChill', err);
                    this._logError(err);
                    return;
                }

                this._sendElasticEvent(ON_DEMAND.CHILL_LOADING, 'onLoadChill', url);
                this._HybridService.loadRemoteChill(url, ver);
            });
    }

    _logError(err){
        this._HybridService.logger.error('CHILL_LOADING_ERROR: ' + err);
    }

    _getChillUrl(grschillUrl){
        let url = grschillUrl.includes('http') ? grschillUrl : 'https://' + grschillUrl;
        return url + 'hybrid_chill/chill.zip';
    }


    getTimeOut() {
        return this._model.getTimeOut();
    }

    onHybridDirectCall(data) {
        this._executeFunc(data);
    }

    _executeFunc(data) {
        const fn = this._model.getFuncName(data);

        if ('function' === typeof this[fn]) {
            this[fn](data);
        }
    }


    setStartOndemand(b) {
        this._isOdrRealProgress = b;
    }

    onLoadError(data) {
        let error = data[KEY_NAME.DATA];
        this._sendElasticEvent(ON_DEMAND.GAME_LOADING_ERROR, 'Error in onLoadError', error);
    }

    onLowDiskSpacError(data) {
        let error = data[KEY_NAME.DATA];
        this._sendElasticEvent(ON_DEMAND.GAME_LOADING_ERROR, 'Error in LowDiskSpac', error);
        //this._HybridService.closeByLowDiskSpace();
    }

    onUpdateProgresBar(data) {
        try{
            if(data[KEY_NAME.RESOURCE_NAME]){
                this.updateProgressBarV2(data)
            }else{
                //to support old version that send only fake progress
                this.updateProgressBarV1(data)
            }

        }catch (e){
            this._sendElasticEvent(ON_DEMAND.GAME_LOADING_ERROR, 'Error in onUpdateProgresBar');
            this.logger.error('Error in onUpdateProgresBar, error msg: ', e)
        }
    }

    updateProgressBarV1(data){
        let statusBar = data[KEY_NAME.DATA];
        Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_UPDATE, statusBar);
    }

    updateProgressBarV2(data) {
        const progressbarfake = data[KEY_NAME.PROGRESS_BAR_FAKE];
        const progressbarreal = data[KEY_NAME.PROGRESS_BAR_REAL];
        const resourcename = data[KEY_NAME.RESOURCE_NAME];
        const resourcexofmeny = data[KEY_NAME.X_OF_MENY];
        const gameType = data[KEY_NAME.GAME_ID];
        const sharedolder = data[KEY_NAME.SHARED_FOLDER];

        Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_UPDATE_V2, {
            statusBar: progressbarreal,
            numberOfPackages: resourcexofmeny
        });

        //TODO not sure we want to keep this log in the long term, for now we need  in order to analyse CIP8 Apple rejection
        if(progressbarreal % 10 === 0){
           this._sendElasticEvent(ON_DEMAND.GAME_LOADING_REAL_ODR_STARTED, gameType + '_' + resourcexofmeny + '_' + resourcename + '_' + sharedolder + '_' + progressbarfake, progressbarreal);
        }
    }

    /**
     * save the game in cookie
     */
    saveOnDemandLoadedGame(gameType, sharedFolder) {
        this._model.saveOnDemandLoadedGame(gameType, sharedFolder);
    }

    /**
     * ask if already the game loaded
     */
    isOnDemandLoadedGame(gameType) {
        return this._model.isOnDemandLoadedGame(gameType);
    }

     _sendElasticEvent(action, label, value){

          const dataToSend  = {
              CGPEventCategory: ON_DEMAND.ON_DEMAND_CATEGORY,
              CGPEventAction: action,
              CGPEventLabel: label,
              CGPEventValue: value
          };

         this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();
    }

    closeGame(){
        DOM.setTimeout(() => {
            this.deleteAllOnDemandGames();
        }, 1000);
    }

    deleteAllOnDemandGames(){
        const games = this._model.getAllOnDemandGames();

        this._deleteGameFolder(games);
    }

    _deleteGameFolder(games) {
        if(games.length > 0) {
            this._HybridService.deleteGameFolder(games).then(data => {
                const remianGames =  this._model.deleteGameFolders(data);
                let res = !_.isEmpty(remianGames) ?  'ODR_ERR ' + remianGames : '';
                this._sendElasticEvent(ON_DEMAND.ON_DEMAND_DELETE_GAMES, 'oldGames: ' + games + ' remianGames: ' + res,0);
            });
        }
    }
}
export default OnDemand;
